import React, { InputHTMLAttributes, useState } from 'react'

import clsxm from '@/utils/clsxm'
import { OptionObject } from '@/utils/form'

import IcChecked from '~/assets/icons/radio-checked.svg'
import IcUnchecked from '~/assets/icons/radio-unchecked.svg'

interface SelectComponentProps extends InputHTMLAttributes<HTMLDivElement> {
  options: OptionObject[]
  selected: string | null
  label?: string
  placeholder?: string
  leftSide?: boolean
  onChangeSelected: (value: string) => void
}

const SelectComponent: React.FC<SelectComponentProps> = ({
  options,
  selected,
  label,
  placeholder = 'Choose',
  leftSide,
  onChangeSelected,
  ...rest
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const handleSelect = (value: string) => {
    onChangeSelected(value)
    setDropdownOpen(false)
  }

  return (
    <div className='relative flex h-full flex-col gap-2'>
      {label && <p className='text-xs font-medium text-dark'>{label}</p>}

      <div
        {...rest}
        className={clsxm(
          'flex h-full cursor-pointer items-center justify-between rounded-lg border border-neutral-border px-3 py-2.5',
          dropdownOpen && 'border-2 border-red/25',
          rest.className
        )}
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <p
          className={clsxm(
            'select-none whitespace-nowrap text-sm font-medium',
            selected != null ? 'text-black' : 'text-form-placeholder'
          )}
        >
          {options.find((opt) => opt.value == selected)?.label || placeholder}
        </p>

        <div className='flex cursor-pointer items-center justify-center'>
          <i className={clsxm('text-2xl text-black', dropdownOpen ? 'kek-arrow-up-s-line' : 'kek-arrow-down-s-line')} />
        </div>
      </div>

      {dropdownOpen && (
        <div
          className={clsxm(
            'absolute right-0 top-15 z-[9999] h-[244px] w-full overflow-y-auto rounded-lg bg-white p-3 pr-1.5 shadow-dropdown md:w-[240px]',
            leftSide && 'left-0'
          )}
        >
          <div className='h-full overflow-scroll pr-1.5'>
            {options.map((opt) => (
              <div
                key={opt.value}
                className={clsxm(
                  'flex h-11 cursor-pointer items-center justify-between gap-2 rounded-lg px-3 py-2.5',
                  opt.value == selected && 'bg-orange'
                )}
                onClick={() => handleSelect(opt.value)}
              >
                <p
                  className={clsxm('text-sm -tracking-[0.084px]', opt.value == selected ? 'text-black' : 'text-gray-2')}
                >
                  {opt.label}
                </p>

                {opt.value == selected ? (
                  <IcChecked className={clsxm('block h-5 w-5')} />
                ) : (
                  <IcUnchecked className={clsxm('block h-5 w-5')} />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default SelectComponent
